var map = {
	"./ariana_grande.jpg": 6508,
	"./carolina_herrera.jpg": 5913,
	"./chanel.jpg": 2065,
	"./dior.jpg": 796,
	"./givenchy.jpg": 6381,
	"./halloween.jpg": 8225,
	"./kenzo.jpg": 2007,
	"./lancome.jpg": 7105,
	"./mancera.jpg": 8151,
	"./paco_rabanne.jpg": 7229,
	"./paris_hilton.jpg": 9448,
	"./prada.jpg": 6106,
	"./ralph_lauren.jpg": 5567,
	"./yves_saint_laurent.jpg": 5707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6149;